module.exports = __webpack_public_path__ + "img/profile-user.415adf5d.png";